/**
 * ActorCell (TRA-1626): who did it, as the table and the detail sheet
 * show it. The email or id on one line, and under it, in muted text, what
 * kind of actor it was when that matters: TrainLoop staff (by the person,
 * whatever role they acted in), one of our jobs, or an API key. Plain
 * text, not a chip, so a row stays short and the mark is read, not seen.
 */

import type { AuditEvent } from '@/hooks/useAuditEvents'

import { actorLabel, actorNote } from './auditLabels'

export function ActorCell({ event }: { event: AuditEvent }): React.JSX.Element {
  const note = actorNote(event)
  return (
    <span className="flex flex-col leading-tight">
      <span className="break-words text-sm">{actorLabel(event)}</span>
      {note !== null && <span className="text-xs text-muted-foreground">{note}</span>}
    </span>
  )
}
